/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable no-var, global-require */
/* global window, document */

import 'core-js';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import smoothscroll from 'smoothscroll-polyfill';
import { ReactQueryConfigProvider } from 'react-query';

import 'normalize.css';
import './styles/main.scss';


// to avoid css order issues, need to declare them explicitly
import '../bphComponents/bundle';
import './appUnauthorized/appUnauthorizedStylesIndex';
import './applicationFrame/applicationFrameStylesIndex';
import './contentViews/contentViewStylesIndex';
import './components/componentStylesIndex';
import './features/featureStylesIndex';
import './applicationFrame/applicationFrameStylesIndex';

import { loadAppManifest } from '../utilities/appManifest';

import ConnectedIntlProvider from './localization/ConnectedIntlProvider';
import { UIStateProvider } from './hooks/useUIState';
import { UIEditProvider } from './hooks/useUIEdit';
import { SaveGlobalHistory } from './appAuthorized/redux/NavigationActions';

import ApplicationFrame from './views/app/ApplicationFrame';
import store from './redux/reduxStore_authorizedApp';
import PublicApp from './appPublic/PublicApp';
import { NavigationHistoryProvider } from './hooks/useNavigate';

if (!window.Promise) {
  window.Promise = Promise;
}

if (!window.Intl) {
  import(/* webpackChunkName: "intl-polyfill" */ 'intl');
}

smoothscroll.polyfill();

window.BPH = window.BPH || {};

const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  },
};

const AppEntry = () => (
  <Provider store={store}>
    <ReactQueryConfigProvider config={queryConfig}>
    <UIStateProvider>
      <UIEditProvider>
        <ConnectedIntlProvider>
          <BrowserRouter>
            <NavigationHistoryProvider>
            <SaveGlobalHistory>
              <Switch>
                <Route path="/public" component={PublicApp} />
                <Route path="/policy" component={PublicApp} />
                <Route path="/">
                  <ApplicationFrame store={store} />
                </Route>
              </Switch>
            </SaveGlobalHistory>
            </NavigationHistoryProvider>
          </BrowserRouter>
        </ConnectedIntlProvider>
      </UIEditProvider>
    </UIStateProvider>
    </ReactQueryConfigProvider>
  </Provider>
);

const HotApp = hot(AppEntry);

const loadApp = () => {
  ReactDOM.render(<HotApp />, document.getElementById('app'));
};

loadAppManifest().then(() => {
  window.addEventListener('routeChange', () => loadApp());
  loadApp();
});
